import fetch from 'cross-fetch';
import { actions as comicNewsActions } from '../features/comicNews';
import { actions as commentsActions } from '../features/comments';
import { actions as homepageActions } from '../features/homepage';
import { actions as storiesActions } from '../features/stories';

export let baseApiUrl = 'https://api.neorice.com';
if (process.env.NODE_ENV === 'development') {
  baseApiUrl = 'http://127.0.0.1:5000';
}

function handleErrors(response) {
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return response;
}

function urlFormEncode(data) {
  return Object.entries(data).map(
    entry => `${encodeURIComponent(entry[0])}=${encodeURIComponent(entry[1])}`
  ).join('&');
}

function apiRequest(method, endpoint, actions) {
  return function(params = null, data = null) {
    const interpolatedEndpoint = endpoint.replaceAll(/\{(.+?)}/g, (match, p1) => {
      return params[p1] === undefined ? '' : params[p1];
    });

    let fetchParams = {
      credentials: 'include',
      method: method,
    };
    if (['POST', 'PUT'].indexOf(method) !== -1) {
      fetchParams = Object.assign({}, fetchParams, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        body: data ? urlFormEncode(data) : undefined,
      });
    }

    return function(dispatch) {
      dispatch(actions.loading(null, params));

      return fetch(`${baseApiUrl}${interpolatedEndpoint}`, fetchParams)
      .then(handleErrors)
      .then(response => response.json())
      .then(json => {
        dispatch(actions.success(json, params));
        return json;
      })
      .catch(function(error) {
        console.log(error);
        dispatch(actions.error(error, params));
        // Rethrow, so that promises waiting for this request know it failed
        throw(error);
      });
    };
  };
}

function getApiRequest(endpoint, action) {
  return apiRequest('GET', endpoint, action);
}

function postApiRequest(endpoint, action) {
  return apiRequest('POST', endpoint, action);
}

// function putApiRequest(endpoint, action) {
//   return apiRequest('PUT', endpoint, action);
// }
//
// function deleteApiRequest(endpoint, action) {
//   return apiRequest('DELETE', endpoint, action);
// }

export const hohGet = getApiRequest('/stories/hoh', storiesActions);
// export const aptggGet = getApiRequest('/stories/aptgg', storiesActions);
export const homepageGet = getApiRequest('/news', homepageActions);
export const comicNewsGet = getApiRequest('/news/{story}/{id}', comicNewsActions);
export const newsCommentsGet = getApiRequest('/news/{id}/comments', commentsActions);
export const commentPost = postApiRequest('/news/{id}/comment', commentsActions);
